import { addRegionToLauncherUrl, resolveClgUrl } from '@/hooks/use-promotion-launcher/utils';
import type { LauncherUrlResolutionContext } from '@/utils/url/launcher-url';

const TARGET_BLANK = '_blank' as const;

export type PromotionGameLaunchContext = {
    isMobile: boolean;
    isXsellWrapper: boolean;
    isAndroidWrapper: boolean;
    addGameWindow: (gameWindow: Window) => void;
    region: string | undefined;
    launcherResolution: LauncherUrlResolutionContext;
};

const shouldNavigateInSameWindow = (ctx: PromotionGameLaunchContext): boolean =>
    ctx.isXsellWrapper || ctx.isAndroidWrapper || ctx.isMobile;

/**
 * Opens game URLs using the same resolution and window rules as usePromotionLauncher.
 */
export const launchGameWindow = (url: string, ctx: PromotionGameLaunchContext): void => {
    const launcherUrl = resolveClgUrl(url, ctx.launcherResolution);
    const resolvedUrl = addRegionToLauncherUrl(launcherUrl, ctx.region);

    if (shouldNavigateInSameWindow(ctx)) {
        window.location.href = resolvedUrl;
        return;
    }

    const width = 1280;
    const height = 720;
    const left = Math.round((screen.width - width) / 2);
    const top = Math.round((screen.height - height) / 2);
    const gameWindow = window.open(
        resolvedUrl,
        TARGET_BLANK,
        `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no`
    );
    if (gameWindow) {
        ctx.addGameWindow(gameWindow);
    }
};

// Backward compatible alias while callers migrate.
export const launchPromotionGameWindow = launchGameWindow;
